import { useId } from "react";
import type { IconProps } from "./types";

export default function FiveADayIcon({ size = 24, color = "currentColor", title, ...svgProps }: IconProps) {
    const maskId = useId();

    return (
        <svg
            viewBox="13.5 14.5 38 38"
            width={size}
            height={size}
            color={color}
            fill="none"
            role={title ? "img" : undefined}
            aria-hidden={title ? undefined : true}
            aria-label={title}
            xmlns="http://www.w3.org/2000/svg"
            {...svgProps}
        >
            {title ? <title>{title}</title> : null}
            <defs>
                <mask id={maskId} maskUnits="userSpaceOnUse" x="0" y="0" width="64" height="64">
                    <rect width="64" height="64" fill="white" />
                    <path d="M22 38h20" stroke="black" strokeWidth="2.5" strokeLinecap="round" />
                </mask>
            </defs>
            <circle cx="20.5" cy="28.5" r="5.5" fill="currentColor" opacity=".66" />
            <circle cx="29" cy="24" r="6" fill="currentColor" />
            <circle cx="38" cy="24.5" r="5.5" fill="currentColor" opacity=".82" />
            <circle cx="45" cy="29.5" r="5" fill="currentColor" />
            <circle cx="32.5" cy="31.5" r="5.5" fill="currentColor" opacity=".55" />
            <path
                d="M16 32h32c-1.1 11.2-6.7 17-16 17s-14.9-5.8-16-17Z"
                fill="currentColor"
                mask={`url(#${maskId})`}
            />
        </svg>
    );
}
